<span *ngIf="!completed; else showComplete" class="countdown-timer fw-bold">
  {{ remainingTime$ | async | countdownFormat }}
</span>
<ng-template #showComplete>
  <span>
    {{ completeText }}
  </span>
</ng-template>
